import templateUrl from "emun.cart/enter-payment/enter-payment.htm";
import "emun.cart/enter-payment/enter-payment.scss";
import controller from "emun.cart/enter-payment/enter-payment.controller";

export default {
  templateUrl,
  controller,
  bindings: {
    cartId: "@",
    token: "@"
  }
};
